import { ContextService } from '../../../services/context_service';
import { DatenverwaltungKataloge } from './DatenverwaltungKataloge';
import { DatenverwaltungKlima } from './DatenverwaltungKlima';
import { DatenverwaltungTabBereichsstruktur } from './DatenverwaltungTabBereichsstruktur';
import { DatenverwaltungTabEnergie } from './DatenverwaltungTabEnergie';
import { DatenverwaltungTabInhalteSupportParameter } from './DatenverwaltungTabInhalteSupportParameter';
import { DatenverwaltungTabMehrsprachigkeit } from './DatenverwaltungTabMehrsprachigkeit';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { Routing } from '../../../helpers/Routing';
import { RoutingIDs } from '../../../helpers/RoutingAdminIDs';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';

interface DatenverwaltungProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    routing: any;
    standortSelected: any;
}

interface DatenverwaltungState {
    tabIndex: number;
}

export class Datenverwaltung extends React.Component<DatenverwaltungProps, DatenverwaltungState> {

    constructor(props: any) {
        super(props);
        this.state = {
            tabIndex: null
        };
        this.devFeaturesMap = require('../../../wips.config.js').devFeaturesMap || {};
    }

    @lazyInject(ContextService) private contextService: ContextService;

    private devFeaturesMap: any = {};
    private disabled: string[] = [];
    private prefix: string = 'admin.tab.datenverwaltung';
    private rechte: any = {};
    private tabName: string = RoutingIDs.TABS_DATENVERWALTUNG;
    private tabIndex: string = `${this.tabName}Index`;
    private tabRoutings: any[] = [
        { path: RoutingIDs.ROUTE_DATENVERWALTUNG_BEREICHSSTRUKTUR },
        { path: RoutingIDs.ROUTE_DATENVERWALTUNG_ENERGIE },
        { path: RoutingIDs.ROUTE_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER },
        { path: RoutingIDs.ROUTE_DATENVERWALTUNG_CO2_FUSSABDRUCK },
        { path: RoutingIDs.ROUTE_DATENVERWALTUNG_KATALOGE }
    ];
    private tabs: string[] = ['bereichsstruktur', 'energie', 'inhalte', 'co2', 'kataloge', 'mehrsprachigkeit']; // Reitereihenfolge beachten

    componentDidMount(): void {
        (new Routing(this)).init((rechte: any, tabIndex: number) => {
            this.rechte = rechte || {};
            this.rechte.mehrsprachigkeit = this.rechte.mehrsprachigkeit && this.devFeaturesMap.N207_MEHRSPRACHIGKEIT;
            this.setTabIndex(tabIndex, this.tabRoutings[tabIndex]);
        });
    }

    componentDidUpdate(prevProps: any): void {
        if (JSON.stringify(this.props.routing) !== JSON.stringify(prevProps.routing)) {
            this.checkRouting();
        }
    }

    checkRouting(): void {
        const routing: any = this.props.routing || {};
        if (typeof (routing.path || {})[this.tabName] === 'undefined') {
            return;
        }
        // this.setTabIndex(routing.path[this.tabName], routing, () => {
        //     if (routing.path.terminateOn === this.tabName) {
        //         this.props.onRoutingChange({});
        //     }
        // });
        if (this.state.tabIndex === routing.path[this.tabName]) {
            if (routing.path.terminateOn === this.tabName) {
                this.props.onRoutingChange({});
            }
        } else {
            this.setTabIndex(routing.path[this.tabName], routing);
        }
    }

    render(): JSX.Element {
        if (this.state.tabIndex === null) {
            return null;
        }

        return (
            <Tabs
                className='tabs-admin-datenverwaltung'
                selectedIndex={this.state.tabIndex}
                onSelect={(tabIndex, lastIndex, event) => this.setTabIndex(tabIndex, this.tabRoutings[tabIndex])}
            >
                <TabList>
                    <Tab disabled={!this.rechte.bereichsstruktur}>Bereichsstruktur</Tab>
                    <Tab disabled={!this.rechte.energie}>Energie</Tab>
                    <Tab disabled={!this.rechte.inhalte}>Inhalte / Support / Parameter</Tab>
                    <Tab disabled={!this.rechte.co2}>CO₂-Fußabdruck</Tab>
                    <Tab disabled={!this.rechte.kataloge}>Kataloge</Tab>
                    <Tab disabled={!this.rechte.mehrsprachigkeit}>Mehrsprachigkeit</Tab>
                </TabList>
                <TabPanel>
                    {this.rechte.bereichsstruktur &&
                        <DatenverwaltungTabBereichsstruktur {...this.props} />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.energie &&
                        <DatenverwaltungTabEnergie {...this.props} />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.inhalte &&
                        <DatenverwaltungTabInhalteSupportParameter {...this.props} />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.co2 &&
                        <DatenverwaltungKlima {...this.props} />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.kataloge &&
                        <DatenverwaltungKataloge {...this.props} />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.mehrsprachigkeit &&
                        <DatenverwaltungTabMehrsprachigkeit {...this.props} />
                    }
                </TabPanel>
            </Tabs>
        );
    }

    setTabIndex(tabIndex: number, tabRouting: any, callback?: () => void): void {
        if (this.state.tabIndex !== tabIndex) {
            setTimeout(() => {
                this.setState({ tabIndex }, () => {
                    this.props.onRoutingChange(tabRouting);
                    this.contextService.set(this.tabIndex, tabIndex);

                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            });
        }
    }
}
